import client from './client'

export default {
  getLookmeItem: (id_number_mim) => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/lookme/', { params: { id_number_min: id_number_mim, id_number_max: id_number_mim + 99 } })
        .then(res => resolve({ results: res.data.results }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },
  getLookmeCount: () => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/lookme/')
        .then(res => resolve({ latest_num: res.data.results[0]["id_number"] }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },
  getLookmeInputDate: () => {
    return new Promise((resolve, reject) => {
      client.get('https://www.hideki.co.jp/api/lookme/')
        .then(res => resolve({ input_date: res.data.results[0]["input_date"] }))
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  },
}
